import { EventBroker } from "../../../lib/utils/event-broker";

export const EVENTS = {
    INIT: 'INIT',
    CLOSE: 'CLOSE',
    TEXT_CHANGED: 'TEXT_CHANGED',
    IMAGE_CHANGED: 'IMAGE_CHANGED',
    SHAPE_CHANGED: 'SHAPE_CHANGED',
    CUSTOM_GROUP_CHANGED: 'GROUP_CHANGED',
    PRODUCT_DIMENSION_CHANGED: 'PRODUCT_DIMENSION_CHANGED',
    ANIMATION_MODULE_CHANGED: 'ANIMATION_MODULE_CHANGED',
    ANIMATION_MODULE_PREVIEW: 'ANIMATION_MODULE_PREVIEW',
    PROPERTIES_MODULE_CHANGED: 'PROPERTIES_MODULE_CHANGED',
    SET_ACTIVE_OBJECT: 'SET_ACTIVE_OBJECT',
    TRANSLATE: 'TRANSLATE',
    TOGGLE_LOADING: 'TOGGLE_LOADING',
    GLOBAL_UPDATE: 'GLOBAL_UPDATE',
    WALMART_FOLDER_CHANGED: 'WALMART_FOLDER_CHANGED',
    CHANGE_IMAGE_PROPERTIES: 'CHANGE_IMAGE_PROPERTIES',
    EXTEND_CONTAINER: 'EXTEND_CONTAINER',
    EXTEND_CONTAINER_SETTINGS_CHANGED: 'EXTEND_CONTAINER_SETTINGS_CHANGED',
    SMART_OBJECT_CHANGED_SAVE: 'SMART_OBJECT_CHANGED_SAVE',
    TEXT_SELECTION_CHANGED: 'TEXT_SELECTION_CHANGED',
    APPLY_TO_PROPERTIES: 'APPLY_TO_PROPERTIES',
    FIT_TEXT_WIDTH: 'FIT_TEXT_WIDTH',
    PRODUCT_REPLACED: 'PRODUCT_REPLACED',
    SHAPE_PROPERTIES_CHANGED: 'SHAPE_PROPERTIES_CHANGED',
    BG_COLOR_CHANGED: 'BG_COLOR_CHANGED',
    OPEN_REPLACE_PRODUCT_IMAGE: 'OPEN_REPLACE_PRODUCT_IMAGE',
    PRODUCT_IMAGE_DROPDOWN_VISIBILITY_CHANGED: 'PRODUCT_IMAGE_DROPDOWN_VISIBILITY_CHANGED',
    PRODUCTS_ANGLE_CHANGED: 'PRODUCTS_ANGLE_CHANGED',
}

export const CANVAS_EVENTS = {
    REDRAW_ADDITIONAL_MULTI_LINE_TEXT: 'REDRAW_ADDITIONAL_MULTI_LINE_TEXT',
}

export const editorControlEventBroker = new EventBroker();
export const canvasEventBroker = new EventBroker();
